import { SiteConversionTrackingHelper } from 'shared/events/site_conversion_tracking_helper';

$(document).ready(() => {
  // Associated with email form CTA or US users
  $('#collections-page-marketing-header-sign-up-form').submit(event => {
    const signupTracker = new SiteConversionTrackingHelper('Collection page header', event);
    signupTracker.trackConversion();
  });

  // Associated with sign up button CTA or non-US users
  $('#collections-page-marketing-header-sign-up-button').click(event => {
    const signupTracker = new SiteConversionTrackingHelper('Collection page header', event);
    signupTracker.trackConversion();
  });
});
